// apps/codeframe/src/chrome/timeline/lottieTransport.ts
import { getLottieHandles } from '../../lottie/registry';

/** Fan a transport action out to a frame's lottie clips. Seeks wrap to each
 *  clip's own duration so scrubbing a long timeline loops short clips in place. */
export function driveLottie(frameId: string, action: 'play' | 'pause' | 'seek', ms = 0): void {
  for (const h of getLottieHandles(frameId)) {
    if (action === 'play') h.play();
    else if (action === 'pause') h.pause();
    else h.seek(h.durationMs > 0 ? ms % h.durationMs : 0);
  }
}
